import {GameIconContainerDefaultBox} from "./game-icon-container.default.box";

export const GameIconContainerBox = GameIconContainerDefaultBox;